import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

function normalizeHex(color: string): string | null {
  if (!color) return null;
  let c = color.trim().toLowerCase();
  if (c.startsWith('#')) c = c.slice(1);
  if (c.length === 3) {
    if (!/^[0-9a-f]{3}$/i.test(c)) return null;
    c = c
      .split('')
      .map(ch => ch + ch)
      .join('');
  }
  if (!/^[0-9a-f]{6}$/i.test(c)) return null;
  return `#${c}`;
}

@Component({
  selector: 'app-color-editor-overlay',
  templateUrl: './color-editor-overlay.component.html',
  styleUrls: ['./color-editor-overlay.component.scss'],
})
export class ColorEditorOverlayComponent implements OnInit, OnDestroy {
  @Input() initialColors: string[] = [];
  @Output() done = new EventEmitter<string[] | null>();

  @ViewChild('closeBtn') closeBtn?: ElementRef<HTMLButtonElement>;

  colors: { value: string; invalid: boolean }[] = [];

  ngOnInit(): void {
    this.colors = (this.initialColors || []).map(c => {
      const n = normalizeHex(c);
      return { value: n ?? c ?? '', invalid: !n };
    });
    setTimeout(() => this.closeBtn?.nativeElement?.focus(), 0);
  }

  ngOnDestroy(): void {}

  addColor() {
    this.colors.push({ value: '#000000', invalid: false });
  }

  removeColor(i: number) {
    this.colors.splice(i, 1);
  }

  onDrop(ev: CdkDragDrop<any[]>) {
    moveItemInArray(this.colors, ev.previousIndex, ev.currentIndex);
  }

  onHexInput(i: number, event: Event) {
    const val = (event.target as HTMLInputElement).value;
    const n = normalizeHex(val);
    this.colors[i].value = val;
    this.colors[i].invalid = !n;
  }

  onColorPicker(i: number, event: Event) {
    const val = (event.target as HTMLInputElement).value;
    const n = normalizeHex(val);
    this.colors[i].value = n ?? val;
    this.colors[i].invalid = !n;
  }

  save() {
    const result: string[] = [];
    for (const c of this.colors) {
      const n = normalizeHex(c.value);
      if (!n) {
        c.invalid = true;
        return;
      }
      result.push(n);
    }
    this.done.emit(result);
  }

  cancel() {
    this.done.emit(null);
  }

  backdropClick(e: MouseEvent) {
    if (e.target === e.currentTarget) this.cancel();
  }

  keydown(e: KeyboardEvent) {
    if (e.key === 'Escape') {
      e.preventDefault();
      this.cancel();
    }
  }
}
